import axios from "axios";
import { paymentRequest } from "src/handler/accountHandler";

const RazorPayPayment = () => {
  const handlePayment = async () => {
    
    // Step 1: Create order from backend
    const response = await paymentRequest({
      "amount": 10000,
      "isVerify": false,
    }); // ₹500

    // Step 2: Open Razorpay modal
    const options = {
      key: "rzp_live_TBn52b1tKUN8vF",
      amount: response.data.paymentCreateResponse.amount,
      currency: response.data.paymentCreateResponse.currency,
      order_id: response.data.paymentCreateResponse.orderId,
      name: "My Project",
      description: "Test Transaction",
      handler: async function (response) {
        await paymentRequest({
          "amount": 0,
          "isVerify": true,
          "orderId": response.razorpay_order_id,
          "paymentId": response.razorpay_payment_id,
          "signature": response.razorpay_signature,
        });
      },
      theme: { color: "#3399cc" },
    };

    const rzp = new (window as any).Razorpay(options);
    rzp.open();

  };

  return <button onClick={handlePayment}>Pay Now</button>;
};

export default RazorPayPayment;
